module.exports = __webpack_public_path__ + "img/icon-admin-account.fd3b9c9.svg";